import karteApi from "../../api/kartes";
import * as mutationTypes from "../mutation-types";
import { fetchKarteImages as fetchKarteImagesEntity } from "../../entities/karte-image";


const state = {
  karteList: [],
  siblingKarteList: [],
  karte: {},
  karteImageList: [],
  karteImageListRequestSeq: 0,
  karteReferenceInfo: [],
  karteUpdateResult: false,
  karteMediaFile: null,
};


const getters = {
  karteList: state => state.karteList,
  siblingKarteList: state => state.siblingKarteList,
  karte: state => state.karte,
  karteImageList: state => state.karteImageList,
  karteReferenceInfo: state => state.karteReferenceInfo,
  karteUpdateResult: state => state.karteUpdateResult,
  karteMediaFile: state => state.karteMediaFile,
};


const actions = {
  fetchKartes({ commit }, params) {
    return new Promise((resolve, reject) => {
      karteApi.fetchKartes(karteList => {
        commit(mutationTypes.ASSIGN_KARTES, { karteList });
        resolve();
      },
      () => {
        reject();
      }, params);
    });
  },

  fetchSiblingKartes({ commit }, params) {
    return new Promise((resolve, reject) => {
      karteApi.fetchSiblingKartes(siblingKarteList => {
        commit(mutationTypes.ASSIGN_SIBLING_KARTES, { siblingKarteList });
        resolve();
      }, 
      () => {
        reject();
      }, params);
    });
  },

  findKarte({ commit }, params) {
    return new Promise((resolve) => {
      karteApi.findKarte(karte => {
        commit(mutationTypes.ASSIGN_KARTE, { karte });
        resolve();
      }, params);
    });
  },

  updateKarte({ commit }, params) {
    return new Promise((resolve) => {
      karteApi.updateKarte(
        params,
        () => {
          let karteUpdateResult = true;
          commit(mutationTypes.KARTE_UPDATE_RESULT, { karteUpdateResult });
          resolve();
        },
        () => {
          let karteUpdateResult = false;
          commit(mutationTypes.KARTE_UPDATE_RESULT, { karteUpdateResult });
          resolve();
        });
    });
  },

  fetchKarteImages({ commit, state }, params) {
    const requestSeq = (state.karteImageListRequestSeq || 0) + 1;
    commit(mutationTypes.ASSIGN_KARTE_IMAGE_LIST_REQUEST, { requestSeq });

    return fetchKarteImagesEntity(params || {})
      .then((karteImageList) => {
        // Ignore stale in-flight responses (e.g., route changed and a newer request started)
        if (state.karteImageListRequestSeq !== requestSeq) return;
        commit(mutationTypes.ASSIGN_KARTE_IMAGE_LIST, { karteImageList });
      })
      .catch(() => {
        // If this request is already outdated, don't surface an error
        if (state.karteImageListRequestSeq !== requestSeq) return;
        return Promise.reject();
      });
  },

  findKarteReferenceInfo({ commit }, params) {
    return new Promise((resolve) => {
      karteApi.findKarteReferenceInfo(karteReferenceInfo => {
        commit(mutationTypes.ASSIGN_KARTE_REFERENCE_INFO, { karteReferenceInfo });
        resolve();
      }, params);
    });
  },

  uploadFile({ dispatch }, params) {
    return new Promise((resolve) => {
      karteApi.uploadFile(() => {
        dispatch("fetchKarteImages", { reservation_id: params.get("reservation_id") })
          .finally(() => resolve());
      }, params);
    });
  },

  deleteFile({ dispatch }, params) {
    return new Promise((resolve) => {
      karteApi.deleteFile(() => {
        dispatch("fetchKarteImages", params)
          .finally(() => resolve());
      }, params);
    });
  },

  viewFile({ commit }, mediaId) {
    return new Promise((resolve) => {
      karteApi.show( mediaFile => {
        commit(mutationTypes.ASSIGN_KARTE_MEDIA_FILE, { mediaFile });
        resolve();
      }, mediaId);
    });
  },

  clearKarte({ commit }) {
    let karte = { load_finish: false };
    commit(mutationTypes.ASSIGN_KARTE, { karte });
  },
  clearKartes({ commit }) {
    let karteList = [];
    commit(mutationTypes.ASSIGN_KARTES, { karteList });
  },
  clearSiblingKartes({ commit }) {
    let siblingKarteList = [];
    commit(mutationTypes.ASSIGN_SIBLING_KARTES, { siblingKarteList });
  }
};


const mutations = {
  [mutationTypes.ASSIGN_KARTES](state, { karteList }) {
    state.karteList = karteList;
  },

  [mutationTypes.ASSIGN_SIBLING_KARTES](state, { siblingKarteList }) {
    state.siblingKarteList = siblingKarteList;
  },

  [mutationTypes.ASSIGN_KARTE](state, { karte }) {
    state.karte = karte;
  },

  [mutationTypes.ASSIGN_KARTE_IMAGE_LIST](state, { karteImageList }) {
    state.karteImageList = karteImageList;
  },

  [mutationTypes.ASSIGN_KARTE_IMAGE_LIST_REQUEST](state, { requestSeq }) {
    state.karteImageListRequestSeq = requestSeq;
  },

  [mutationTypes.ASSIGN_KARTE_REFERENCE_INFO](state, { karteReferenceInfo }) {
    state.karteReferenceInfo = karteReferenceInfo;
  },

  [mutationTypes.KARTE_UPDATE_RESULT](state, { karteUpdateResult }) {
    state.karteUpdateResult = karteUpdateResult;
  },

  [mutationTypes.ASSIGN_KARTE_MEDIA_FILE](state, { mediaFile }) {
    state.karteMediaFile = mediaFile;
  },
};


export default {
  state,
  getters,
  actions,
  mutations
};
